export const environment = {
  production: false,
  apiBaseUrl: 'https://horterpayoutsapi.him-ria.com/api/',
  recaptchaKey: '6LcT0TAUAAAAALmuoZUbPzksGvWxe59ImAMQwHMq',
  siteTitle: 'Horter Investments'
};
